<div *ngIf="isPrint && !isOldPrintEnable">
  <iframe id="{{elementIds.receipt_iframe_print}}" style="display: block;height: 1px;"></iframe>
</div>

<div
  style="position: fixed; top: 0;left:0; text-align: center; background-color: black; width: 100%; height: 100%; margin: 0px; padding: 0px; opacity: 0.5; z-index: 100;margin-left:-12px;"
  *ngIf="isPrint && isOldPrintEnable">
  <span>{{localService.languageContent.common.close_print}}</span>
  <br />
  <button class="button_icon button_icon_color"
    style="transform: rotate(45deg);font-size: 50px !important;  margin-top: 50px !important;  color: red !important;"
    title="{{localService.languageContent.common.close}}" (click)="isPrint = false;">add_circle_outline</button>
</div>